export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9608.a4ab5f9b.jpg";